var _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 567,
    viewBox: "0 0 701 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 701,
    height: 567
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.00146484,
    width: 700,
    height: 566.715,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.00146484,
    width: 749,
    height: 573,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -2.46326,
    cy: 278.826,
    rx: 278.521,
    ry: 276.866,
    fill: "#F2F4FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -1.97035,
    cy: 278.336,
    rx: 246.479,
    ry: 245.014,
    fill: "#49DBA3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -2.46315,
    cy: 278.826,
    rx: 37.9577,
    ry: 37.7322,
    fill: "#E9ECFC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149 445.074C149 424.046 159.714 407 172.93 407C181.237 407 188.553 413.737 192.844 423.961C194.293 423.361 195.847 423.051 197.417 423.047C201.417 423.047 205.116 425.088 208.132 428.543C212 415.795 220.202 407 229.695 407C238.571 407 246.312 414.695 250.444 426.114C252.739 424.185 255.631 423.102 258.634 423.047C268.776 423.047 276.999 436.129 276.999 452.266C277.041 457.646 276.059 462.985 274.105 468H153.826C150.798 461.622 149 453.683 149 445.074Z",
    fill: "#29C88B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 469H551V467H0V469Z",
    fill: "#6FEFBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 400H657V398H0V400Z",
    fill: "#47EDAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.484 366.427C228.868 378.635 227.327 397.402 227.327 397.402C227.327 397.402 246.241 396.376 258.857 384.167C271.473 371.959 273.014 353.192 273.014 353.192C273.014 353.192 254.1 354.218 241.484 366.427Z",
    fill: "#6FEFBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.847 370.056C282.249 386.951 266.501 397.415 266.501 397.415C266.501 397.415 258.207 380.486 262.805 363.591C267.403 346.696 283.151 336.233 283.151 336.233C283.151 336.233 291.445 353.161 286.847 370.056Z",
    fill: "#3F3D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.706 384.014C283.865 395.705 266.758 397.561 266.758 397.561C266.758 397.561 267.227 380.461 278.068 368.769C288.909 357.078 306.017 355.222 306.017 355.222C306.017 355.222 305.547 372.322 294.706 384.014Z",
    fill: "#6FEFBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.634 191.192L268.974 184.559L222.27 143.106H103.84V179.585L180.569 230.986L260.634 191.192Z",
    fill: "#29B17D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2484 166.359V143.934H97.9723V149.426L103.841 143.106L142.205 184.559L157.217 194.508L180.494 363.56L145.39 398.455H63.8081V186.217L82.2484 166.359Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.205 184.559H268.974V398.455H142.205V184.559Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.0012 382.778C36.0012 368.695 44.8617 357.278 55.7917 357.278C62.6615 357.278 68.7119 361.79 72.2604 368.638C73.4789 368.233 74.7564 368.026 76.0425 368.025C79.3684 368.081 82.5438 369.4 84.9041 371.706C88.1028 363.169 94.8857 357.278 102.737 357.278C110.077 357.278 116.479 362.432 119.896 370.08C121.9 368.756 124.256 368.042 126.669 368.025C135.057 368.025 141.857 376.787 141.857 387.595C141.882 391.24 141.064 394.844 139.465 398.132H39.9924C37.325 393.444 35.9492 388.151 36.0012 382.778Z",
    fill: "#45D69E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.415 346.224H219.768V398.455H196.415V346.224Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M244.788 361.147V352.857H254.795V361.147H245.621H244.788Z",
    fill: "#6FEFBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.621 367.78H254.795V376.07H244.788V367.78H245.621Z",
    fill: "#6FEFBD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.108 352.857H238.116V361.148H228.108V352.857Z",
    fill: "#6FEFBD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228.108 367.78H238.116V376.07H228.108V367.78Z",
    fill: "#6FEFBD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.399 361.147V352.857H186.407V361.147H177.233H176.399Z",
    fill: "#6FEFBD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.233 367.78H186.407V376.07H176.399V367.78H177.233Z",
    fill: "#6FEFBD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.719 352.857H169.727V361.148H159.719V352.857Z",
    fill: "#6FEFBD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.719 367.78H169.727V376.07H159.719V367.78Z",
    fill: "#6FEFBD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.342 195.336V187.046H116.351V195.336H107.176H106.342Z",
    fill: "#29B17D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.176 201.969H116.351V210.26H106.342V201.969H107.176Z",
    fill: "#29B17D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6608 187.046H99.6689V195.337H89.6608V187.046Z",
    fill: "#29B17D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6608 201.969H99.6689V210.26H89.6608V201.969Z",
    fill: "#29B17D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.342 241.764V233.473H116.351V241.764H107.176H106.342Z",
    fill: "#29B17D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.176 248.396H116.351V256.687H106.342V248.396H107.176Z",
    fill: "#29B17D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6608 233.473H99.6689V241.764H89.6608V233.473Z",
    fill: "#29B17D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6608 248.396H99.6689V256.687H89.6608V248.396Z",
    fill: "#29B17D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.342 288.191V279.9H116.351V288.191H107.176H106.342Z",
    fill: "#29B17D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.176 294.823H116.351V303.114H106.342V294.823H107.176Z",
    fill: "#29B17D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6608 279.901H99.6689V288.191H89.6608V279.901Z",
    fill: "#29B17D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6608 294.823H99.6689V303.114H89.6608V294.823Z",
    fill: "#29B17D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M106.342 334.618V326.327H116.351V334.618H107.176H106.342Z",
    fill: "#29B17D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M107.176 341.25H116.351V349.541H106.342V341.25H107.176Z",
    fill: "#29B17D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6608 326.327H99.6689V334.618H89.6608V326.327Z",
    fill: "#29B17D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6608 341.25H99.6689V349.541H89.6608V341.25Z",
    fill: "#29B17D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M158.05 195.337H254.795V215.234H158.05V195.337Z",
    fill: "#6FEFBD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M158.05 235.131H254.795V255.029H158.05V235.131Z",
    fill: "#6FEFBD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M158.05 274.926H254.795V294.824H158.05V274.926Z",
    fill: "#6FEFBD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M158.05 314.72H254.795V334.618H158.05V314.72Z",
    fill: "#6FEFBD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M496.002 382.463C496.002 367.296 505.543 355 517.314 355C524.712 355 531.228 359.859 535.05 367.234C536.362 366.798 537.737 366.576 539.122 366.575C542.704 366.634 546.124 368.055 548.666 370.539C552.11 361.344 559.415 355 567.87 355C575.775 355 582.67 360.55 586.349 368.787C588.507 367.362 591.044 366.592 593.643 366.575C602.676 366.575 609.999 376.011 609.999 387.651C610.026 391.577 609.145 395.458 607.423 399H500.3C497.427 393.951 495.946 388.25 496.002 382.463Z",
    fill: "#49DBA3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M311.396 469.906C309.521 469.906 308 463.859 308 456.4C308 448.942 309.521 442.895 311.396 442.895C313.272 442.895 314.793 448.942 314.793 456.4C314.793 463.859 313.272 469.906 311.396 469.906Z",
    fill: "#2F2E41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M331.209 167.15C329.334 167.15 327.813 161.103 327.813 153.644C327.813 146.185 329.334 140.139 331.209 140.139C333.085 140.139 334.606 146.185 334.606 153.644C334.606 161.103 333.085 167.15 331.209 167.15Z",
    fill: "#2F2E41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M351.235 205.546C350.449 223.256 355.865 240.688 366.559 254.873C377.254 269.058 392.565 279.119 409.885 283.34C427.204 287.561 445.461 285.682 461.543 278.023C477.625 270.363 490.538 257.398 498.081 241.336C505.625 225.273 507.333 207.108 502.913 189.934C498.494 172.76 488.221 157.641 473.844 147.153C459.468 136.665 441.878 131.456 424.072 132.414C406.265 133.373 389.344 140.439 376.191 152.409C368.703 159.186 362.642 167.372 358.359 176.493C354.075 185.614 351.654 195.489 351.235 205.546ZM504.655 212.273C502.796 254.159 467.004 286.732 424.868 284.884C382.732 283.037 349.964 247.457 351.823 205.572C353.682 163.687 389.474 131.113 431.61 132.961C473.746 134.809 506.513 170.388 504.655 212.273Z",
    fill: "#6FEFBD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M475.806 163.915C476.157 156.004 483.095 149.883 491.302 150.242C499.509 150.602 505.878 157.307 505.527 165.218C505.176 173.13 498.238 179.251 490.031 178.891C481.824 178.531 475.455 171.826 475.806 163.915Z",
    fill: "#6FEFBD"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M435.452 215.286C423.369 215.286 413.574 205.549 413.574 193.537C413.574 181.526 423.369 171.789 435.452 171.789C447.536 171.789 457.331 181.526 457.331 193.537C457.331 205.549 447.536 215.286 435.452 215.286Z",
    fill: "#030822"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M442.447 209.635C442.447 209.635 441.315 229.893 443.58 229.893C445.844 229.893 429.427 239.46 429.427 239.46L419.238 233.833V227.08C419.238 227.08 432.824 225.392 427.163 210.761C421.502 196.13 442.447 209.635 442.447 209.635Z",
    fill: "#9F616A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M489.998 431.911L491.696 448.793L486.035 450.481L481.506 445.98L479.808 431.911H489.998Z",
    fill: "#9F616A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M408.481 441.478L405.651 452.169L397.726 457.234L389.234 452.732L398.858 436.976L408.481 441.478Z",
    fill: "#9F616A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M437.067 218.358C428.001 218.358 420.651 211.052 420.651 202.039C420.651 193.026 428.001 185.72 437.067 185.72C446.134 185.72 453.484 193.026 453.484 202.039C453.484 211.052 446.134 218.358 437.067 218.358Z",
    fill: "#9F616A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M446.975 263.094L450.937 261.406C450.937 261.406 457.731 257.467 458.297 249.589C458.863 241.711 452.636 231.582 452.636 231.582L443.578 228.768L432.937 237.378L432.823 251.277L446.975 263.094Z",
    fill: "#9F616A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M450.938 232.707L453.202 231.581C453.202 231.581 464.524 231.019 465.656 244.524C466.789 258.029 470.751 280.538 470.751 280.538C470.751 280.538 479.809 296.295 479.242 313.176L483.771 327.807C483.771 327.807 489.998 349.191 482.639 349.191C475.28 349.191 475.846 326.119 475.846 326.119C475.846 326.119 462.26 293.481 461.128 287.854C459.995 282.227 450.372 255.779 453.202 248.463C456.033 241.148 450.938 232.707 450.938 232.707Z",
    fill: "#9F616A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M442.446 268.159V274.349C442.446 274.349 438.484 278.85 440.182 281.664C441.88 284.478 443.579 290.105 443.579 290.105L435.653 302.485L409.047 304.736L403.756 269.498L442.446 268.159Z",
    fill: "#9F616A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M417.539 228.768L413.01 226.517C413.01 226.517 403.386 219.764 395.461 218.639L371.119 202.32L355.269 164.617C355.269 164.617 355.835 144.359 351.306 146.61C346.778 148.861 347.344 166.305 347.344 166.305C347.344 166.305 355.835 201.194 363.194 210.761C370.553 220.327 397.159 236.083 397.159 236.083C397.159 236.083 404.519 244.524 403.952 248.463C403.386 252.402 417.539 228.768 417.539 228.768Z",
    fill: "#9F616A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M438.483 290.105C438.483 290.105 444.71 286.166 448.673 292.919C452.635 299.671 459.994 301.359 464.523 321.618C469.052 341.876 479.808 373.951 482.638 376.202C485.468 378.453 497.356 402.087 490.563 435.288H479.241L469.618 387.456C469.618 387.456 438.483 349.191 436.219 333.435L426.029 392.521C426.029 392.521 425.463 415.03 416.972 425.721L407.914 447.105L396.027 441.478L409.613 387.456C409.613 387.456 402.82 332.872 407.348 317.678L407.999 297.759C407.999 297.759 426.595 298.546 438.483 290.105Z",
    fill: "#2F2E41"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M486.035 445.98H492.828C493.96 445.98 503.018 453.295 499.055 457.234C495.093 461.173 488.866 468.489 488.866 468.489C488.866 468.489 466.788 471.28 466.222 467.341C465.656 463.402 475.846 454.983 475.846 454.983L478.676 445.98C478.676 445.98 484.337 439.79 486.035 445.98Z",
    fill: "#2F2E41"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M396.027 451.607C396.027 451.607 405.65 451.044 407.349 450.481C409.047 449.918 412.444 465.112 407.349 466.237C402.254 467.363 381.309 469.051 381.309 469.051C381.309 469.051 364.892 468.488 366.024 463.986C367.157 459.485 389.234 450.481 389.234 450.481C389.234 450.481 392.064 444.854 396.027 451.607Z",
    fill: "#2F2E41"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M440.747 228.205L443.578 226.517L446.974 229.331C446.974 229.331 436.785 236.083 439.049 242.273C441.313 248.463 450.937 261.406 450.937 261.406C450.937 261.406 442.446 270.972 442.446 274.348C442.446 274.348 420.368 266.47 403.952 274.348C403.952 274.348 403.952 263.094 401.687 260.843C399.423 258.592 398.291 250.714 403.952 243.961C407.94 238.993 411.536 233.725 414.707 228.205L420.368 224.829L423.284 225.748C423.284 225.748 417.538 232.144 423.199 232.707C428.86 233.27 437.917 231.581 440.747 228.205Z",
    fill: "#6FEFBD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M419.462 156.458C421.386 158.592 424.02 159.964 426.88 160.32C431.825 161.023 427.94 168.748 427.94 168.748C427.94 168.748 429.352 165.939 426.527 163.481C423.701 161.023 419.462 159.618 419.462 156.458Z",
    fill: "#030822"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M428.997 176.424C425.629 176.424 422.9 173.71 422.9 170.363C422.9 167.015 425.629 164.302 428.997 164.302C432.364 164.302 435.094 167.015 435.094 170.363C435.094 173.71 432.364 176.424 428.997 176.424Z",
    fill: "#030822"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M421.878 176.331C426.588 173.885 434.692 171.962 438.997 172.099L437.908 167.96C434.096 170.534 426.036 172.494 420.789 172.192L421.878 176.331Z",
    fill: "#49DBA3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M431.611 176.696C431.611 176.696 439.034 186.182 453.879 188.291C468.725 190.399 457.06 213.589 457.06 213.589C457.06 213.589 461.302 205.156 452.819 197.777C444.336 190.399 431.611 186.182 431.611 176.696Z",
    fill: "#030822"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M431.044 176.133C431.044 176.133 426.802 190.89 420.44 192.998C414.077 195.106 417.259 217.242 427.863 219.35C427.863 219.35 418.849 207.228 424.151 197.741C429.453 188.255 432.634 180.876 431.044 176.133Z",
    fill: "#030822"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M331.21 151.394H370.27V155.896H331.21V151.394Z",
    fill: "#2F2E41"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M370.27 167.15C368.394 167.15 366.873 161.103 366.873 153.645C366.873 146.186 368.394 140.139 370.27 140.139C372.146 140.139 373.667 146.186 373.667 153.645C373.667 161.103 372.146 167.15 370.27 167.15Z",
    fill: "#2F2E41"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M311.398 454.15H350.458V458.652H311.398V454.15Z",
    fill: "#2F2E41"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M350.457 469.906C348.581 469.906 347.06 463.859 347.06 456.401C347.06 448.942 348.581 442.895 350.457 442.895C352.333 442.895 353.854 448.942 353.854 456.401C353.854 463.859 352.333 469.906 350.457 469.906Z",
    fill: "#2F2E41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHealth);
export default __webpack_public_path__ + "static/media/MobileHealth.65abb00da17b9f5c753d33be58fc11e4.svg";
export { ForwardRef as ReactComponent };